module.exports = __webpack_public_path__ + "static/media/digital-ocean.add23917.svg";